import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'

import { useStores } from '@trivie/core'

import { TableHelper } from '../../../../tables'
import { ContestTable } from '../../../../tables/contest-table'

const LiveContests: React.FunctionComponent = observer(() => {
  const { contestStore } = useStores()
  const { setTriggerRefresh, triggerRefresh } = contestStore

  const [tableHelper] = useState(
    new TableHelper('list_live_contests', 'contests', 'contests', undefined, 'live'),
  )

  useEffect(() => {
    if (triggerRefresh) {
      tableHelper.load().then(() => setTriggerRefresh(false))
    }
    return () => {
      setTriggerRefresh(undefined)
    }
  }, [triggerRefresh])

  return <ContestTable forceLoading={triggerRefresh} filter="live" tableHelper={tableHelper} />
})

export const LiveContestsTab = () => {
  return {
    name: 'Live',
    path: `/activities/contests/live`,
    component: () => <LiveContests />,
  }
}
